
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


const Redirect_Login = () =>{
	const navigate = useNavigate();

	const set_system = async ()=>{
		let params = new URLSearchParams(window.location.search);
		if(params.has("system")){
			localStorage.setItem("system", params.get("system"));
		}
		navigate('/login')
	}
	useEffect(()=>{
		
		set_system()
	});
}

export default Redirect_Login;